// extracted by mini-css-extract-plugin
export default {"loaderContainer":"searchForTournament_loaderContainer__2Vknr","searchInputWrapper":"searchForTournament_searchInputWrapper__iGHqe"};